import { ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';

export const CustomToggleButtonGroup = ({
  value,
  onChange,
  items,
}: {
  value: string;
  onChange: (value: string) => void;
  items: { label: string; value: string }[];
}) => {
  return (
    <ToggleButtonGroup
      value={value}
      exclusive
      onChange={(_, value) => value && onChange(value)}
      fullWidth
      sx={{
        borderRadius: 1.5,
        border: '1px solid',
        borderColor: 'divider',
        '& .MuiToggleButtonGroup-grouped': {
          border: 'none',
          borderRadius: 1.5,
          textTransform: 'none',
          fontWeight: 500,
          fontSize: '0.875rem',
        },
        '.MuiToggleButton-root': {
          margin: 0,
          '&:focus': {
            outline: 'none',
          },
        },
      }}
    >
      {items.map((option) => (
        <ToggleButton
          key={option.value}
          value={option.value}
          sx={{
            py: 1,
            '&.Mui-selected': {
              backgroundColor: 'primary.main',
              color: 'primary.contrastText',
              '&:hover': {
                backgroundColor: 'primary.main',
                color: 'primary.contrastText',
              },
            },
          }}
        >
          <Typography noWrap>{option.label}</Typography>
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
};
